export const categories = [
  "Atta, Rice & Dal",
  "Ghee, Oil & Masala", //NP
  "Dry Fruits & Vrat Items", //NP
  "Dairy & Bread", //NP
  "Biscuit, Chips & Namkeen", //NP
  "Chocolates & Ice Cream", //NP
  "Instant Food",
  "Sauces & Spreads",
  "Tea & Coffee",
  "Cold Drinks & Juices", //NP
  "Personal Care",
  "Cleaning Essentials", //NP
  "Other Home Items", //NP
  "Hygiene & Shaving",
  "Baby Care",
  "Combos", //NP
];
